import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const aggregatorSlice = createSlice({
  name: "AggregatorReducer",
  initialState: {
    pageNo: 1,
    pageSize: 10,
    searchParam: null,
  },
  reducers: {
    setAggregatorPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setAggregatorPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setAggregatorSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAggregatorPageNo,
  setAggregatorPageSize,
  setAggregatorSearchParam,  
} = aggregatorSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default aggregatorSlice.reducer;